import { render, staticRenderFns } from "./SettingsSupport.vue?vue&type=template&id=6ebfed00&scoped=true&"
import script from "./SettingsSupport.vue?vue&type=script&lang=js&"
export * from "./SettingsSupport.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSupport.vue?vue&type=style&index=0&id=6ebfed00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfed00",
  null
  
)

export default component.exports